// useProductosListXL - Sprint 44 Fase 3 Vista 3.
// Hook de lista de productos con filtros, paginacion, categorias y msg
// auto-dismiss 4s. Reusa apiClient directamente (no hay service dedicado
// en legacy — era inline).
import { useCallback, useEffect, useRef, useState } from 'react';
import apiClient from '../../../api/apiClient';

const DEFAULT_PER_PAGE = 20;
const MSG_AUTO_DISMISS_MS = 4000;

export default function useProductosListXL() {
  const [items, setItems]         = useState([]);
  const [total, setTotal]         = useState(0);
  const [pages, setPages]         = useState(1);
  const [loading, setLoading]     = useState(false);
  const [err, setErr]             = useState(null);

  const [page, setPage]           = useState(1);
  const [perPage, setPerPage]     = useState(DEFAULT_PER_PAGE);
  const [q, setQ]                 = useState('');
  const [categoria, setCategoria] = useState('');
  const [estado, setEstado]       = useState('');
  const [categorias, setCategorias] = useState([]);
  const [msg, setMsg]             = useState(null);

  const msgTimer = useRef(null);
  const pushMsg = useCallback((kind, text) => {
    if (msgTimer.current) clearTimeout(msgTimer.current);
    setMsg({ kind, text });
    msgTimer.current = setTimeout(() => setMsg(null), MSG_AUTO_DISMISS_MS);
  }, []);
  useEffect(() => () => {
    if (msgTimer.current) clearTimeout(msgTimer.current);
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setErr(null);
    try {
      const params = new URLSearchParams({
        page: String(page),
        per_page: String(perPage),
      });
      if (q)         params.set('q', q);
      if (categoria) params.set('categoria', categoria);
      if (estado)    params.set('estado', estado);
      const res = await apiClient.get('/productos/?' + params.toString());
      const d = (res && res.data) || {};
      setItems(d.items || []);
      setTotal(d.total || 0);
      setPages(Math.max(1, d.pages || 1));
    } catch (e) {
      setErr((e && e.message) || 'Error al cargar productos');
      setItems([]);
      setTotal(0);
      setPages(1);
    } finally {
      setLoading(false);
    }
  }, [page, perPage, q, categoria, estado]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    let alive = true;
    apiClient.get('/productos/categorias')
      .then((r) => { if (alive) setCategorias((r && r.data && r.data.items) || []); })
      .catch(() => { if (alive) setCategorias([]); });
    return () => { alive = false; };
  }, []);

  // Reset page a 1 al cambiar filtros.
  const resetAndSetQ         = useCallback((v) => { setPage(1); setQ(v); }, []);
  const resetAndSetCategoria = useCallback((v) => { setPage(1); setCategoria(v); }, []);
  const resetAndSetEstado    = useCallback((v) => { setPage(1); setEstado(v); }, []);

  const canPrev = page > 1;
  const canNext = page < pages;

  return {
    items, total, pages, loading, err,
    page, perPage, setPage, setPerPage,
    canPrev, canNext,
    q, setQ: resetAndSetQ,
    categoria, setCategoria: resetAndSetCategoria,
    estado, setEstado: resetAndSetEstado,
    categorias,
    msg, pushMsg, clearMsg: () => setMsg(null),
    load,
  };
}
